var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"mx-auto",class:{
        'deleted-slot': _vm.leaveslot.deleted,
        'taken': _vm.leaveslot.bid,
        'biddable': _vm.isSelectable,
        'selected': _vm.isSelected,
        'allowed': _vm.isAllowed,
    },style:(("border-bottom: 4px solid " + (_vm.leaveslot.bgcolor))),on:{"click":_vm.bid}},[(_vm.leaveslot.bid)?_c('div',{staticClass:"slot-crew"},[_vm._v(" "+_vm._s(_vm.leaveslot.bid.crew_tag)+" ")]):_vm._e(),(_vm.leaveslot.bid)?_c('span',[_vm._v(" "+_vm._s(_vm.checkPrivacy ? _vm.leaveslot.bid.bidder_init : '**')+" ")]):(_vm.isSelected)?_c('span',[_vm._v(" "+_vm._s(_vm.bidder.init)+" ")]):_c('span',[_vm._v("   ")])])}
var staticRenderFns = []

export { render, staticRenderFns }